import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// SEM service worker (04/09/2026). O register() pre-cacheava index.html e o
// bundle: quem ja tinha visitado a pagina seguia rodando o JavaScript antigo
// depois de cada deploy — e abria chamado no Octadesk mesmo com o servidor ja
// apontando para o nosso motor. Esta pagina e um formulario: nao precisa de
// offline, precisa de estar SEMPRE na versao do servidor.
// O /service-worker.js em public/ e o desligamento para quem ainda tem o antigo.
serviceWorkerRegistration.unregister();